import { render, staticRenderFns } from "./muestrasCliente.vue?vue&type=template&id=38d03134&scoped=true"
import script from "./muestrasCliente.vue?vue&type=script&lang=js"
export * from "./muestrasCliente.vue?vue&type=script&lang=js"
import style0 from "./muestrasCliente.vue?vue&type=style&index=0&id=38d03134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d03134",
  null
  
)

export default component.exports